import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as jQuery from "jquery";
(window as any).$ = (window as any).jQuery = jQuery;

// import * as jQuery from "jquery";
// (window as any).$ = (window as any).jQuery = jQuery;


if (environment.production) {
  enableProdMode();
  const script = document.createElement('script');
  script.innerHTML = `(!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s)}(window,document,'script',
	'https://connect.facebook.net/en_US/fbevents.js');
	fbq('init', '529358080757684'); 
	fbq('track', 'PageView'););`;
  document.head.appendChild(script);
  const noscript = document.createElement('noscript');
	var DOM_img = document.createElement("img");
	DOM_img.src = "https://www.facebook.com/tr?id=529358080757684&ev=PageView&noscript=1";
	DOM_img.height = 1;
	DOM_img.width= 1;
	noscript.appendChild(DOM_img);
	document.head.appendChild(noscript);
}

platformBrowserDynamic().bootstrapModule(AppModule);




// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/main.ts